import { useEffect, useState } from "react";
import CircularProgress from "@mui/material/CircularProgress";
import "./deviceDealersList.css";
import { Fragment } from "react";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import {
  getDeviceDealerData,
  deleteDealerInformation,
} from "./../../action/deviceDealer";
import DisplayDeviceDealerDeatils from "./deviceDealerDetailsPage";
import customConfig from "../../config";
import Button from "../Common/Button/Button";
import {
  InfoPairLabel,
  InfoPairValue,
  SectionSubHeading,
} from "../Common/Typography/AppTypography";
import { useDesignTokens } from "../../theme/useDesignTokens";
import Dialog from "../Common/Dailog/Dailog";
import { Box, Paper } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import DataTable from "../Common/DataTable/DataTable";
import IncrementalPagination from "../Common/DataTable/IncrementalPagination";
import IconButton from "../Common/Button/IconButton";

const DeviceDealerList = ({
  setAlert,
  countryCodeFilter,
  onEditDeviceDealerDetails,
  showUpdatedDealerInfo,
  userRoleInfo,
}) => {
  const { colors } = useDesignTokens();

  const headers = {
    id: "ID",
    name: "Name",
    email: "Email",
    website: "Website",
    // editDeviceDealerDetails: "Edit",
    // deleteDeviceDealerDetails: "Delete",
  };

  const isPermissionGranted =
    userRoleInfo.level > 4 ||
    userRoleInfo.roles.includes(customConfig.roleCloudAdmin);

  if (isPermissionGranted) {
    headers["editDeviceDealerDetails"] = "Edit";
    headers["deleteDeviceDealerDetails"] = "Delete";
  }

  const [deviceDealersData, setDeviceDealersData] = useState([]);
  const [updateFlag, setUpdateFlag] = useState(undefined);
  const [isLoading, setIsLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(0);
  const [paginationStartIndex, setPaginationStartIndex] = useState(0);
  const [lastApiPageFetched, setLastApiPageFetched] = useState(0);
  const [pageEndReached, setPageEndReached] = useState(false);
  const [showDeviceDealerDetails, setShowDeviceDealerDetails] = useState(false);
  const [
    selectedDeviceDealerDetailsForDisplay,
    setSelectedDeviceDealerDetailsForDisplay,
  ] = useState({});
  const [showDealerDevicesList, setShowDealerDevicesList] = useState(false);
  const [deleteDeviceDealer, setDeleteDeviceDealer] = useState(false);
  const [selectedDealerDetailsForDelete, setSelectedDealerDetailsForDelete] =
    useState({});

  const [pageSize, setPageSize] = useState(20);
  const pageSizeOptions = [20, 40, 100];
  const totalPageCount = Math.ceil(deviceDealersData?.length / pageSize);
  const startIndex = pageSize * currentPage;
  const endIndex = startIndex + pageSize;

  useEffect(() => {
    setCurrentPage(0);
    setPaginationStartIndex(0);
    setPageEndReached(false);
    setLastApiPageFetched(0);
    setUpdateFlag(Math.random());
    setShowDealerDevicesList(true);
    setSelectedDealerDetailsForDelete({});
    setSelectedDeviceDealerDetailsForDisplay({});
  }, []);

  useEffect(() => {
    if (updateFlag) {
      updateDevcieDealersData();
    }
  }, [updateFlag]);

  useEffect(() => {
    if (showUpdatedDealerInfo) {
      updateDevcieDealersData();
      setShowDeviceDealerDetails(false);
      setSelectedDeviceDealerDetailsForDisplay({});
    }
  }, [showUpdatedDealerInfo]);

  //   const pageNumbersToShow = () => {
  //     if (totalPageCount === 0) {
  //       return [0];
  //     } else {
  //       let i = paginationStartIndex;
  //       let pagesToShow = [];
  //       while (i < totalPageCount && i < paginationStartIndex + 5) {
  //         pagesToShow.push(i);
  //         i += 1;
  //       }
  //       return pagesToShow;
  //     }
  //   };

  const handlePageSizeChange = (newSize) => {
    if (!newSize || newSize === pageSize) return;
    setPageSize(newSize);
    setCurrentPage(0);
    setLastApiPageFetched(0);
    setPageEndReached(false);
    updateDevcieDealersData(0, null, null, newSize);
  };

  const handlePageChange = (newPage) => {
    if (newPage < 0) {
      return;
    }

    const loadedPageCount = Math.ceil(deviceDealersData.length / pageSize);

    if (newPage < loadedPageCount) {
      setCurrentPage(newPage);
      return;
    }

    if (pageEndReached) {
      setAlert("You have reached end of page.", "danger");
      return;
    }

    updateDevcieDealersData(lastApiPageFetched + 1, (data) => {
      if (data.length < 100) {
        setPageEndReached(true);
      }

      if (data.length === 0) {
        setAlert("You have reached end of page.", "danger");
        return;
      }

      setDeviceDealersData((prev) => [...prev, ...data]);
      setLastApiPageFetched((prev) => prev + 1);
      setCurrentPage(newPage);
    });
  };

  //   const getPaginationData = () => {
  //     const pageArr = pageNumbersToShow();
  //     return (
  //       <ul className="pagination">
  //         <li
  //           className={paginationStartIndex === 0 ? "disabled" : "waves-effect"}
  //           onClick={() => {
  //             if (!(paginationStartIndex === 0)) {
  //               setPaginationStartIndex(Math.max(0, paginationStartIndex - 5));
  //             }
  //           }}
  //         >
  //           <a href="#!">
  //             <i className="material-icons">chevron_left</i>
  //           </a>
  //         </li>
  //         {pageArr.map((element) => {
  //           return (
  //             <li
  //               key={element + 1}
  //               className={
  //                 parseInt(element) === parseInt(currentPage) ? "active" : ""
  //               }
  //             >
  //               <a href="#" onClick={() => setCurrentPage(element)}>
  //                 {element + 1}
  //               </a>
  //             </li>
  //           );
  //         })}
  //         <li
  //           className={
  //             paginationStartIndex >= totalPageCount - 5
  //               ? "disabled"
  //               : "waves-effect"
  //           }
  //           onClick={() => {
  //             if (!pageEndReached) {
  //               const pageArr = pageNumbersToShow();
  //               if (pageArr[-1] + 1 === totalPageCount) {
  //                 setPaginationStartIndex(
  //                   Math.min(totalPageCount, paginationStartIndex + 5),
  //                 );
  //               } else {
  //                 updateDevcieDealersData(
  //                   lastApiPageFetched + 1,
  //                   nextPaginationResolveFunc,
  //                 );
  //               }
  //             } else {
  //               setAlert("You have reached end of page.", "danger");
  //             }
  //           }}
  //         >
  //           <a href="#!">
  //             <i className="material-icons">chevron_right</i>
  //           </a>
  //         </li>
  //       </ul>
  //     );
  //   };

  //   const nextPaginationResolveFunc = (data) => {
  //     if (data.length < 100) {
  //       setPageEndReached(true);
  //     }
  //     if (data.length === 0) {
  //       setAlert("You have reached end of page.", "danger");
  //     } else {
  //       const newPaginationStartIndex = Math.min(
  //         parseInt((deviceDealersData.length + data.length) / pageSize),
  //         paginationStartIndex + 5,
  //       );
  //       setPaginationStartIndex(newPaginationStartIndex);
  //       setDeviceDealersData([...deviceDealersData, ...data]);
  //       setLastApiPageFetched(lastApiPageFetched + 1);
  //       setCurrentPage(newPaginationStartIndex);
  //     }
  //   };

  const updateDevcieDealersData = (page, resolveFunc, errFunc, customSize) => {
    setIsLoading(true);

    const effectiveSize = customSize ?? pageSize;

    getDeviceDealerData({
      country: countryCodeFilter,
      page: page || lastApiPageFetched,
      size: effectiveSize * 5,
    })
      .then((res) => {
        setIsLoading(false);
        if (!resolveFunc) {
          if (!res || (res && res.length < 100)) {
            setPageEndReached(true);
          }

          if (!res) {
            setDeviceDealersData([]);
          } else {
            setDeviceDealersData(res);
          }
        } else {
          resolveFunc(res);
        }
      })
      .catch((err) => {
        setIsLoading(false);
        if (!errFunc) {
          console.log(err);
          setAlert("Error while fetching data.", "danger");
        } else {
          errFunc(err);
        }
      });
  };

  function editDeviceDealer(deviceDealerDetails) {
    onEditDeviceDealerDetails(deviceDealerDetails);
  }

  function handleDeleteDeviceDealer(deviceDealerDetails) {
    setSelectedDealerDetailsForDelete({
      dealerId: deviceDealerDetails["id"],
      dealerName: deviceDealerDetails["name"],
    });
    setDeleteDeviceDealer(true);
  }

  function handleDeviceDealerClosePopup() {
    setSelectedDealerDetailsForDelete({});
    setDeleteDeviceDealer(false);
  }

  function handleDeleteDeviceDealerFromPopup() {
    deleteDealerInformation(selectedDealerDetailsForDelete["dealerId"])
      .then((res) => {
        setAlert("Dealer Deleted Sucessfully", "success");
        setSelectedDealerDetailsForDelete({});
        setDeleteDeviceDealer(false);
        updateDevcieDealersData();
      })
      .catch((err) => {
        setAlert(
          err?.response?.data?.message ?? "Failed to Delete Dealer",
          "danger",
        );
        setSelectedDealerDetailsForDelete({});
        setDeleteDeviceDealer(false);
      });
  }

  function handleDeleteDeviceDealerDetails() {
    setShowDeviceDealerDetails(false);
    setSelectedDeviceDealerDetailsForDisplay({});
    setSelectedDealerDetailsForDelete({});
    setDeleteDeviceDealer(false);
    updateDevcieDealersData();
  }

  const dealerDeviceColumns = Object.keys(headers).map((key) => ({
    key,
    label:
      key === "editDeviceDealerDetails" || key === "deleteDeviceDealerDetails"
        ? isPermissionGranted
          ? headers[key]
          : ""
        : headers[key],
    headerCellSx: {
      backgroundColor: "#f5f5f5",
      padding: "12px 12px",
    },
    align:
      key === "editDeviceDealerDetails" || key === "deleteDeviceDealerDetails"
        ? "center"
        : "",
    justifyContent:
      key === "editDeviceDealerDetails" || key === "deleteDeviceDealerDetails"
        ? "center"
        : "",
    cellSx: {
      verticalAlign: "middle",
      padding: "10px 12px",
    },
    render: (val, row) => {
      const strVal = String(val || "");
      const isLong = strVal.length > 200;
      const contentSx = {
        wordBreak: isLong ? "break-all" : "normal",
      };

      if (key === "editDeviceDealerDetails" && isPermissionGranted) {
        return (
          <a
            href="javascript:void(0)"
            onClick={() => {
              editDeviceDealer(row);
            }}
          >
            {/* <EditIcon style={{ color: colors?.primary?.main }}></EditIcon> */}
            <IconButton
              size="small"
              icon={<EditIcon />}
              onClick={() => {
                editDeviceDealer(row);
              }}
            />
          </a>
        );
      }

      if (key === "deleteDeviceDealerDetails" && isPermissionGranted) {
        return (
          <a
            href="javascript:void(0)"
            onClick={() => {
              handleDeleteDeviceDealer(row);
            }}
          >
            {/* <DeleteIcon style={{ color: colors?.error?.main }}></DeleteIcon> */}
            <IconButton
              variant="danger"
              size="small"
              icon={<DeleteIcon />}
              onClick={() => {
                handleDeleteDeviceDealer(row);
              }}
            />
          </a>
        );
      }

      if (key === "id") {
        return (
          <Box
            sx={contentSx}
            onClick={() => {
              setSelectedDeviceDealerDetailsForDisplay(row);
              setShowDeviceDealerDetails(true);
            }}
            style={{ cursor: "pointer", textDecoration: "underline" }}
          >
            {val || "-"}
          </Box>
        );
      }

      return <Box sx={contentSx}>{val || "-"}</Box>;
    },
  }));

  if (isLoading || deviceDealersData.length === 0) {
    return (
      <div
        style={{
          display: "grid",
          placeItems: "center",
          height: "80vh",
        }}
      >
        <CircularProgress size="5em" style={{ color: "#AFB42B" }} />
      </div>
    );
  }

  return (
    <Fragment>
      {!showDeviceDealerDetails && (
        <Paper elevation={3} sx={{ mt: 1, p: 2, borderRadius: 2, mb: 1 }}>
          <Box
            sx={{
              width: "100%",
              minWidth: 0,
              overflowX: { xs: "auto", lg: "hidden" },
              overflowY: "hidden",
              WebkitOverflowScrolling: "touch",
            }}
          >
            <DataTable
              columns={dealerDeviceColumns}
              data={deviceDealersData.slice(startIndex, endIndex)}
              rowKey="id"
              minWidth={{ xs: 1120, lg: "100%" }}
            //   maxHeight="calc(100vh - 46vh)"
              sx={{
                "& table": {
                  tableLayout: { xs: "auto", lg: "fixed" },
                  minWidth: { xs: 1120, lg: "100%" },
                  width: { xs: "max-content", lg: "100%" },
                },
              }}
              tableContainerSx={{
                boxShadow: "none",
                borderRadius: 1,
                width: { xs: "max-content", lg: "100%" },
                minWidth: { xs: 1120, lg: "100%" },
                border: "1px solid",
                borderColor: "divider",
              }}
              msgForDisplay="No Data found"
            />
          </Box>
          <IncrementalPagination
            page={currentPage}
            pageSize={pageSize}
            dataLength={deviceDealersData.length}
            onPageChange={handlePageChange}
            onPageSizeChange={handlePageSizeChange}
            pageSizeOptions={pageSizeOptions}
            isLastPage={pageEndReached && endIndex >= deviceDealersData.length}
            sx={{ m: 0, mt: 1.5, px: 0 }}
          />
        </Paper>
      )}

      {showDeviceDealerDetails && (
        <Fragment>
          <Box sx={{ mt: 2 }}>
            <Button
              startIcon={<ArrowBackIcon />}
              // size="medium"
              onClick={() => {
                setShowDeviceDealerDetails(false);
                setSelectedDeviceDealerDetailsForDisplay({});
              }}
            >
              Back
            </Button>
          </Box>

          <DisplayDeviceDealerDeatils
            deviceDealerDetails={selectedDeviceDealerDetailsForDisplay}
            displayEditDeleteButton={isPermissionGranted ? true : false}
            onEditDeviceDealerDetails={onEditDeviceDealerDetails}
            setAlert={setAlert}
            onDeleteDeviceDealerDetails={handleDeleteDeviceDealerDetails}
          ></DisplayDeviceDealerDeatils>
        </Fragment>
      )}

      {deleteDeviceDealer &&
        selectedDealerDetailsForDelete &&
        Object.keys(selectedDealerDetailsForDelete).length > 0 && (
          <Fragment>
            <Dialog
              open={deleteDeviceDealer}
              onClose={handleDeviceDealerClosePopup}
              title={"Delete Device Dealer"}
              actions={[
                {
                  label: "Cancel",
                  variant: "ghost",
                  onClick: handleDeviceDealerClosePopup,
                },
                {
                  label: "Delete",
                  tooltip: "Click to delete the dealer profile.",
                  variant: "danger",
                  onClick: handleDeleteDeviceDealerFromPopup,
                  slotProps: {
                    popper: {
                      sx: { zIndex: 2400 },
                    },
                  },
                },
              ]}
              sx={{
                zIndex: 2300,
              }}
            >
              <Box
                sx={{
                  bgcolor: colors?.disabled?.bg,
                  p: 3,
                  borderRadius: 2,
                  textAlign: "left",
                }}
              >
                <SectionSubHeading sx={{ mb: 2 }}>
                  Are you sure you want to delete this dealer profile?
                </SectionSubHeading>

                <Box sx={{ mb: 1 }}>
                  <InfoPairLabel>Dealer ID:</InfoPairLabel>
                  <InfoPairValue>
                    {selectedDealerDetailsForDelete?.["dealerId"] ?? ""}
                  </InfoPairValue>
                </Box>
                <Box>
                  <InfoPairLabel>Name:</InfoPairLabel>
                  <InfoPairValue>
                    {selectedDealerDetailsForDelete?.["dealerName"] ?? ""}
                  </InfoPairValue>
                </Box>
              </Box>
            </Dialog>
          </Fragment>
        )}
    </Fragment>
  );
};

export default DeviceDealerList;
